export const updatedUserMethodsByProduct = (isSingleSubscriptionClient, product, userPaymentMethods, country, paymentMethod) => {
  if (!isSingleSubscriptionClient) {
    return userPaymentMethods;
  }
  const productSubPaymentMethods = selectProductSubPaymentMethods(product, country, paymentMethod);
  return userPaymentMethods.map(userMethod => {
    return {
      ...userMethod,
      disabled: userMethod.type === 'CARD'
        ? !productSubPaymentMethods.includes(userMethod.methodInfo?.brand)
        : !productSubPaymentMethods.includes(userMethod.methodInfo?.paymentMethodId)
    }
  });
};

export const filterSubPaymentMethodsByProduct = (product, subPaymentMethods, country, paymentMethod) => {
  const productSubPaymentMethods = selectProductSubPaymentMethods(product, country, paymentMethod);
  return subPaymentMethods.filter(method => productSubPaymentMethods.includes(method.id));
};

export const selectProductSubPaymentMethods = (product, country, paymentMethod) => {
  if (product.subPaymentMethods) {
    return product.subPaymentMethods[country] || [];
  }
  if (product?.paymentData?.length) {
    const paymentData = product.paymentData.find(data => data.paymentMethod === paymentMethod);
    if (paymentData) {
      return paymentData?.subPaymentMethods[country] || [];
    }
  }

  return [];
};

export const getIdFromPaymentMethodId = (userPaymentMethods, paymentMethodId) => {
  return userPaymentMethods.find(subPaymentMethod => {
    const methodId = subPaymentMethod.type === 'CARD'
      ? subPaymentMethod.methodInfo?.brand
      : subPaymentMethod.methodInfo?.paymentMethodId;
    return methodId === paymentMethodId
  })?._id;
}
